export class MarkdownContent {
  readonly #raw: string;

  private constructor(raw: string) {
    this.#raw = raw;
  }

  static of(raw: string): MarkdownContent {
    return new MarkdownContent(raw);
  }

  get raw(): string {
    return this.#raw;
  }
}
